/*
 * File: 客户模块-客户管理-详情-一页纸-一页纸附件名称
 */
<template>
    <el-dialog
        :visible="visible"
        title="一页纸附件名称"
        width="500px"
        custom-class="paper-file-name-dialog"
        destroy-on-close
        append-to-body
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="handleClose"
    >
        <el-form ref="ruleForm" :model="form" :rules="rules" label-width="80px">
            <el-form-item prop="fileName" label="附件名称">
                <el-input v-model="form.fileName" />
            </el-form-item>
            <el-form-item prop="checkList" label="附件格式">
                <el-radio-group v-model="form.fileFormat">
                    <el-radio label="word">Word</el-radio>
                    <!-- <el-radio label="pdf">PDF</el-radio> -->
                </el-radio-group>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <el-button type="primary" size="small" @click="handleConfirm">确定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { ref, reactive } from '@vue/composition-api';

export default {
    props: {},
    setup(props, setupContext) {
        const emit = setupContext.emit;
        const visible = ref(false);
        const partType = ref('');
        const form = reactive({
            fileName: '',
            fileFormat: 'word'
        });
        const rules = ref({
            fileName: [
                { required: true, message: '附件名称不能为空', trigger: 'change' }
            ]
        });

        const show = (name, part) => {
            visible.value = true;
            form.fileName = name;
            partType.value = part;
            setupContext.root.$nextTick(() => {
                setupContext.refs.ruleForm.clearValidate();
            });
        };
        const handleClose = () => {
            visible.value = false;
            partType.value = '';
        };
        // 确定
        const handleConfirm = () => {
            setupContext.refs.ruleForm.validate((valid) => {
                if (valid) {
                    emit('confirm', form, partType.value);
                    handleClose();
                }
            });
        };
        return {
            visible,
            form,
            rules,
            show,
            handleClose,
            handleConfirm
        };
    }
};
</script>

<style lang="less">
.paper-file-name-dialog {
    border-radius: 12px;
    .el-dialog__title {
        font-size: 16px;
        font-weight: 600;
    }
    // .el-input__inner {
    //     background-color: #F2F3F5;
    //     color: #000;
    //     height: 35px;
    // }
    .el-button {
        border-radius: 8px;
        padding: 10px 32px;
    }
}
</style>
